import Vue from "vue";

/**
 * @author Jose Luis R
 * @return {Object}
 */

const updateAdvanceStatusCROL = () => {
  return Vue.$http
    .get("purchase/sync/advances/crol/")
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export default updateAdvanceStatusCROL;



// WEBPACK FOOTER //
// ./src/services/sinister/updateAdvanceStatusCROL.js